export default {
    items: [
        {value: 0, label: 'Кассовый'},
        {value: 1, label: 'Безналичный'},
        {value: 2, label: 'Бонусный'},
    ]
}